// apps/web/src/services/fel.ts
//
// Frontend wrappers around the INFILE FEL edge functions.
import { supabase } from '@/services/supabase';

export interface NitLookupResult {
  valid:   boolean;
  nit:     string;
  name:    string | null;
  status:  string;
  source:  'cache' | 'infile' | 'local';
  message?: string | null;
  /** Full INFILE payload — extra receptor fields (direccion, correo,
   *  nombre_comercial, regimen, etc.) for verification in the UI. */
  raw?:    Record<string, unknown>;
  debug?:  {
    http_status?:        number;
    raw_body?:           string;
    sent_url?:           string;
    sent_emisor_codigo?: string;
    sent_clave_len?:     number;
    sent_clave_first4?:  string;
    sent_nit_consulta?:  string;
    fel_env?:            string;
  };
}

/**
 * Look up a Guatemala NIT in INFILE's padrón.
 * Returns the legal name (razón social) when valid.
 */
export async function lookupNit(nit: string, accountId?: string): Promise<NitLookupResult> {
  const { data, error } = await supabase.functions.invoke('fel-consult-nit', {
    body: { nit, account_id: accountId },
  });
  if (error) {
    return { valid: false, nit, name: null, status: 'NETWORK_ERROR', source: 'local', message: error.message };
  }
  return data as NitLookupResult;
}

export interface CuiLookupResult {
  valid:    boolean;
  cui:      string;
  name:     string | null;
  deceased: boolean;
  status:   string;
  source:   'cache' | 'infile' | 'local';
}

/**
 * Look up a person by CUI (DPI). Returns the full legal name and deceased flag.
 */
export async function lookupCui(cui: string): Promise<CuiLookupResult> {
  const { data, error } = await supabase.functions.invoke('fel-consult-cui', {
    body: { cui },
  });
  if (error) {
    return { valid: false, cui, name: null, deceased: false, status: 'NETWORK_ERROR', source: 'local' };
  }
  return data as CuiLookupResult;
}
